import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../../../../src/constants';

export const PADDING_OFFSET = 34;

export default StyleSheet.create({
  root: {
    paddingHorizontal: PADDING_OFFSET,
    paddingTop: 12,
  },
  header: {
    flex: 1,
    flexDirection: 'row',
  },
  headerItemLeft: {
    flex: 0,
  },
  headerItemSeparator: {
    width: 1,
    backgroundColor: PALETTE.secondaryText,
    marginVertical: 8,
    marginHorizontal: 20,
  },
  headerItemRight: {
    flex: 1,
  },
  headerItemLabel: {
    color: PALETTE.secondaryText,
  },
  graphHeader: {
    marginBottom: 15,
  },
});
